/**
 * Extensões e códigos da liberação de compra (MedicationDispense).
 * validUntil = extension valueDate; recorded = emissão (não whenHandedOver/statusChanged).
 * @module purchase-release/constants
 */

/** Data fim da liberação (valueDate YYYY-MM-DD) — validade comercial. */
export const PURCHASE_RELEASE_VALID_UNTIL_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/extension/purchase-release/valid-until";

/**
 * Agrupa vários MedicationDispense criados na mesma ação de tela
 * (“uma liberação” com N produtos).
 */
export const PURCHASE_RELEASE_BATCH_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/extension/purchase-release/batch-id";

/**
 * Mesmo UUID da transação documental (receita + ANVISA).
 * Reutiliza a URL de DocumentReference — o lote de dispense herda o vínculo.
 */
export const PURCHASE_RELEASE_TRANSACTION_ID_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/extension/supporting-document/transaction-id";

/** System do código do produto WooCommerce em medication.concept. */
export const WOO_PRODUCT_CODE_SYSTEM =
  "https://fluxmed.com.br/fhir/CodeSystem/woocommerce-product-id";

/**
 * Ligar quando o EHRPoster aceitar Bundle transaction de MedicationDispense.
 * false = POST individual por recurso (servidor atual).
 */
export const USE_MEDICATION_DISPENSE_BUNDLE_POST = false;

/**
 * Ligar quando STATISTICS aceitar MedicationDispense em Bundle batch.
 * true = segundo batch só de dispense (isolado do batch de DocumentReference).
 * Se o segundo batch falhar, a lista segue com docs; liberações ficam lazy
 * até abrir o paciente (GET individual).
 */
export const USE_ECOMMERCE_RESOURCES_BATCH_DISPENSE = true;
